import React, { FC } from 'react';
import classNames from 'classnames';
import { SystemButtonProps } from '../button.types';
import { SystemButtonDefault } from '../systemButtonDefaultProps';
import styles from './brand_button.module.scss';
import { BaseButton } from '../BaseButton';

type Props = {
  large?: boolean;
  expanded?: boolean;
} & SystemButtonProps;

export const BrandButton: FC<Props> = ({
  large,
  dataName,
  expanded,
  ...rest
}) => {
  return (
    <BaseButton
      {...rest}
      className={classNames(styles.brand, {
        [styles.large]: large,
        [styles.small]: !large,
        [styles.expanded]: expanded,
      })}
      name={dataName}
    />
  );
};

BrandButton.defaultProps = {
  ...SystemButtonDefault,
  large: false,
  expanded: false,
};
